export enum DataStateDisplay {
  OkNoData = '-',
  Error = 'Error',
  ErrorFetch = 'Error while fetching...',
  Loading = 'Loading...',
}
